import { BrowserRouter as Router } from "react-router-dom";
// import Connect from './components/Connect';
import { ConnectButton } from '@rainbow-me/rainbowkit';

import Nav from "./components/Nav";
import Footer from "./components/Footer";
import AnimatedRoutes from "./components/AnimatedRoutes";

const App = () => {

    return (
        <div className="wrap">
            <Router>
                <div className="coco">
                    <ConnectButton accountStatus="avatar" />
                </div>
                <AnimatedRoutes />
                <Nav />
                <Footer />
            </Router>
        </div>
    );
};

export default App